import { createActions, handleActions } from 'redux-actions';

const initState = {
  summaryData: [],
  detailData: {},
  fetching: false,
  error: null,
};

export const creators = createActions({
  FYTD_SUMMARY_REQUEST: (selectedMonths) => ({
    selectedMonths,
  }),
  FYTD_DETAIL_REQUEST: (selectedYearMonth) => ({
    selectedYearMonth,
  }),
  FYTD_SUCCESS: (payload) => payload,
  FYTD_FAILURE: (payload) => payload,
});

const summaryReducer = (state) => {
  return {
    ...state,
    fetching: true,
    error: null,
  };
};

const detailReducer = (state) => {
  return {
    ...state,
    fetching: true,
    error: null,
  };
};

const successReducer = (state, { payload }) => {
  const nextState = Object.assign({}, state, payload);
  nextState.fetching = false;
  return nextState;
};

const failureReducer = (state, { payload }) => {
  return { ...state, fetching: false, error: payload };
};

export default handleActions(
  {
    FYTD_SUMMARY_REQUEST: summaryReducer,
    FYTD_DETAIL_REQUEST: detailReducer,
    FYTD_SUCCESS: successReducer,
    FYTD_FAILURE: failureReducer,
  },
  initState,
);
